import * as Html from "../../util/Html.ts";
import * as DateUtils from '../../lib/DateUtils.ts';

function initDom(element: HTMLElement){
  const node = element as HTMLInputElement;
  const inputVisible = node.nextElementSibling as HTMLInputElement;
  if(!inputVisible || inputVisible.type !== 'date') return;

  inputVisible.addEventListener('change', function(){
    if(this.value !== ''){
      const result = new Date(this.value + 'T' + DateUtils.forInputTime(new Date()));
      const resultISO = result.toISOString();

      // Security for infinite loop with change event
      if(resultISO !== node.value){
        node.value = resultISO;
        node.dispatchEvent(new Event('change'));
      }
    } else {
      this.value = DateUtils.forInputDate(new Date(node.value));
    }
  });
}

Html.registerWidget('widget/form/input-date-timenow',{initDom:initDom})

export {initDom}